import { Button, Grid, Typography } from "@mui/material";
import { Fragment } from "react";
import { CompanyPartHeader } from "../../components/PartHeader";
import SwitchMode from "./SwitchMode";
import TRANSACTION_STATE from "./state/TransactionState";
import TransactionTable from "./TransactionTable";

const Content = (props) => {
  const { mode, transactions, setOpenModal, paging } = props;
  return (
    <Fragment>
      <CompanyPartHeader>
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          my={1}
        >
          <Grid item xs="auto">
            <Typography fontWeight="bold" fontSize={20}>
              検索結果
              {transactions.Value.length > 0
                ? `（件数：${paging.Value.totalQuantity}）`
                : ""}
            </Typography>
          </Grid>
          <Grid item xs="auto" display="flex">
            <SwitchMode mode={mode} />
            <Button variant="outlined" onClick={() => setOpenModal(true)}>
              {mode.Value == TRANSACTION_STATE.RECEIPT ? "入金" : "出金"}エントリ
            </Button>
          </Grid>
        </Grid>
      </CompanyPartHeader>

      <TransactionTable
        mode={mode}
        transactions={transactions}
        paging={paging}
      />
    </Fragment>
  );
};

export default Content;
